import ShowOnboarding from '@/pages/Onboarding/ShowOnboarding.vue';
import ShowStepCreate from '@/pages/Onboarding/ShowStepCreate.vue';
import ShowStepConfirm from '@/pages/Onboarding/ShowStepConfirm.vue';
import ShowStepComplete from '@/pages/Onboarding/ShowStepComplete.vue';
import ShowStepProfile from '@/pages/Onboarding/ShowStepProfile.vue';
export default [
    {
        path: 'onboarding',
        name: 'onboarding.show',
        component: ShowOnboarding,
        redirect: { name: 'onboarding.create.show' },
        children: [
            {
                path: 'create',
                name: 'onboarding.create.show',
                component: ShowStepCreate,
                props: true,
            },
            {
                path: 'confirm/:id',
                name: 'onboarding.confirm.show',
                component: ShowStepConfirm,
                props: true,
            },
            {
                path: 'profile/:id',
                name: 'onboarding.profile.show',
                component: ShowStepProfile,
                props: true,
            },
            {
                path: 'complete/:id',
                name: 'onboarding.complete.show',
                component: ShowStepComplete,
                props: true,
            },
        ]
    }
];
